export const countriesList = [
  {
    value: 'AD',
    label: 'Andorra',
    icon: '🇦🇩',
  },
  {
    value: 'AE',
    label: 'United Arab Emirates',
    icon: '🇦🇪',
  },
  {
    value: 'AF',
    label: 'Afghanistan',
    icon: '🇦🇫',
  },
  {
    value: 'AG',
    label: 'Antigua and Barbuda',
    icon: '🇦🇬',
  },
  {
    value: 'AI',
    label: 'Anguilla',
    icon: '🇦🇮',
  },
  {
    value: 'AL',
    label: 'Albania',
    icon: '🇦🇱',
  },
  {
    value: 'AM',
    label: 'Armenia',
    icon: '🇦🇲',
  },
  {
    value: 'AO',
    label: 'Angola',
    icon: '🇦🇴',
  },
  {
    value: 'AR',
    label: 'Argentina',
    icon: '🇦🇷',
  },
  {
    value: 'AS',
    label: 'American Samoa',
    icon: '🇦🇸',
  },
  {
    value: 'AT',
    label: 'Austria',
    icon: '🇦🇹',
  },
  {
    value: 'AU',
    label: 'Australia',
    icon: '🇦🇺',
  },
  {
    value: 'AW',
    label: 'Aruba',
    icon: '🇦🇼',
  },
  {
    value: 'AX',
    label: 'Åland Islands',
    icon: '🇦🇽',
  },
  {
    value: 'AZ',
    label: 'Azerbaijan',
    icon: '🇦🇿',
  },
  {
    value: 'BA',
    label: 'Bosnia and Herzegovina',
    icon: '🇧🇦',
  },
  {
    value: 'BB',
    label: 'Barbados',
    icon: '🇧🇧',
  },
  {
    value: 'BD',
    label: 'Bangladesh',
    icon: '🇧🇩',
  },
  {
    value: 'BE',
    label: 'Belgium',
    icon: '🇧🇪',
  },
  {
    value: 'BF',
    label: 'Burkina Faso',
    icon: '🇧🇫',
  },
  {
    value: 'BG',
    label: 'Bulgaria',
    icon: '🇧🇬',
  },
  {
    value: 'BH',
    label: 'Bahrain',
    icon: '🇧🇭',
  },
  {
    value: 'BI',
    label: 'Burundi',
    icon: '🇧🇮',
  },
  {
    value: 'BJ',
    label: 'Benin',
    icon: '🇧🇯',
  },
  {
    value: 'BL',
    label: 'Saint Barthélemy',
    icon: '🇧🇱',
  },
  {
    value: 'BM',
    label: 'Bermuda',
    icon: '🇧🇲',
  },
  {
    value: 'BN',
    label: 'Brunei Darussalam',
    icon: '🇧🇳',
  },
  {
    value: 'BO',
    label: 'Bolivia, Plurinational State of',
    icon: '🇧🇴',
  },
  {
    value: 'BQ',
    label: 'Bonaire, Sint Eustatius and Saba',
    icon: '🇧🇶',
  },
  {
    value: 'BR',
    label: 'Brazil',
    icon: '🇧🇷',
  },
  {
    value: 'BS',
    label: 'Bahamas',
    icon: '🇧🇸',
  },
  {
    value: 'BT',
    label: 'Bhutan',
    icon: '🇧🇹',
  },
  {
    value: 'BW',
    label: 'Botswana',
    icon: '🇧🇼',
  },
  {
    value: 'BY',
    label: 'Belarus',
    icon: '🇧🇾',
  },
  {
    value: 'BZ',
    label: 'Belize',
    icon: '🇧🇿',
  },
  {
    value: 'CA',
    label: 'Canada',
    icon: '🇨🇦',
  },
  {
    value: 'CC',
    label: 'Cocos (Keeling) Islands',
    icon: '🇨🇨',
  },
  {
    value: 'CD',
    label: 'Congo, Democratic Republic of the',
    icon: '🇨🇩',
  },
  {
    value: 'CF',
    label: 'Central African Republic',
    icon: '🇨🇫',
  },
  {
    value: 'CG',
    label: 'Congo',
    icon: '🇨🇬',
  },
  {
    value: 'CH',
    label: 'Switzerland',
    icon: '🇨🇭',
  },
  {
    value: 'CI',
    label: "Côte d'Ivoire",
    icon: '🇨🇮',
  },
  {
    value: 'CK',
    label: 'Cook Islands',
    icon: '🇨🇰',
  },
  {
    value: 'CL',
    label: 'Chile',
    icon: '🇨🇱',
  },
  {
    value: 'CM',
    label: 'Cameroon',
    icon: '🇨🇲',
  },
  {
    value: 'CN',
    label: 'China',
    icon: '🇨🇳',
  },
  {
    value: 'CO',
    label: 'Colombia',
    icon: '🇨🇴',
  },
  {
    value: 'CR',
    label: 'Costa Rica',
    icon: '🇨🇷',
  },
  {
    value: 'CU',
    label: 'Cuba',
    icon: '🇨🇺',
  },
  {
    value: 'CV',
    label: 'Cabo Verde',
    icon: '🇨🇻',
  },
  {
    value: 'CW',
    label: 'Curaçao',
    icon: '🇨🇼',
  },
  {
    value: 'CX',
    label: 'Christmas Island',
    icon: '🇨🇽',
  },
  {
    value: 'CY',
    label: 'Cyprus',
    icon: '🇨🇾',
  },
  {
    value: 'CZ',
    label: 'Czechia',
    icon: '🇨🇿',
  },
  {
    value: 'DE',
    label: 'Germany',
    icon: '🇩🇪',
  },
  {
    value: 'DJ',
    label: 'Djibouti',
    icon: '🇩🇯',
  },
  {
    value: 'DK',
    label: 'Denmark',
    icon: '🇩🇰',
  },
  {
    value: 'DM',
    label: 'Dominica',
    icon: '🇩🇲',
  },
  {
    value: 'DO',
    label: 'Dominican Republic',
    icon: '🇩🇴',
  },
  {
    value: 'DZ',
    label: 'Algeria',
    icon: '🇩🇿',
  },
  {
    value: 'EC',
    label: 'Ecuador',
    icon: '🇪🇨',
  },
  {
    value: 'EE',
    label: 'Estonia',
    icon: '🇪🇪',
  },
  {
    value: 'EG',
    label: 'Egypt',
    icon: '🇪🇬',
  },
  {
    value: 'EH',
    label: 'Western Sahara',
    icon: '🇪🇭',
  },
  {
    value: 'ER',
    label: 'Eritrea',
    icon: '🇪🇷',
  },
  {
    value: 'ES',
    label: 'Spain',
    icon: '🇪🇸',
  },
  {
    value: 'ET',
    label: 'Ethiopia',
    icon: '🇪🇹',
  },
  {
    value: 'FI',
    label: 'Finland',
    icon: '🇫🇮',
  },
  {
    value: 'FJ',
    label: 'Fiji',
    icon: '🇫🇯',
  },
  {
    value: 'FK',
    label: 'Falkland Islands (Malvinas)',
    icon: '🇫🇰',
  },
  {
    value: 'FM',
    label: 'Micronesia, Federated States of',
    icon: '🇫🇲',
  },
  {
    value: 'FO',
    label: 'Faroe Islands',
    icon: '🇫🇴',
  },
  {
    value: 'FR',
    label: 'France',
    icon: '🇫🇷',
  },
  {
    value: 'GA',
    label: 'Gabon',
    icon: '🇬🇦',
  },
  {
    value: 'GB',
    label: 'United Kingdom of Great Britain and Northern Ireland',
    icon: '🇬🇧',
  },
  {
    value: 'GD',
    label: 'Grenada',
    icon: '🇬🇩',
  },
  {
    value: 'GE',
    label: 'Georgia',
    icon: '🇬🇪',
  },
  {
    value: 'GF',
    label: 'French Guiana',
    icon: '🇬🇫',
  },
  {
    value: 'GG',
    label: 'Guernsey',
    icon: '🇬🇬',
  },
  {
    value: 'GH',
    label: 'Ghana',
    icon: '🇬🇭',
  },
  {
    value: 'GI',
    label: 'Gibraltar',
    icon: '🇬🇮',
  },
  {
    value: 'GL',
    label: 'Greenland',
    icon: '🇬🇱',
  },
  {
    value: 'GM',
    label: 'Gambia',
    icon: '🇬🇲',
  },
  {
    value: 'GN',
    label: 'Guinea',
    icon: '🇬🇳',
  },
  {
    value: 'GP',
    label: 'Guadeloupe',
    icon: '🇬🇵',
  },
  {
    value: 'GQ',
    label: 'Equatorial Guinea',
    icon: '🇬🇶',
  },
  {
    value: 'GR',
    label: 'Greece',
    icon: '🇬🇷',
  },
  {
    value: 'GS',
    label: 'South Georgia and the South Sandwich Islands',
    icon: '🇬🇸',
  },
  {
    value: 'GT',
    label: 'Guatemala',
    icon: '🇬🇹',
  },
  {
    value: 'GU',
    label: 'Guam',
    icon: '🇬🇺',
  },
  {
    value: 'GW',
    label: 'Guinea-Bissau',
    icon: '🇬🇼',
  },
  {
    value: 'GY',
    label: 'Guyana',
    icon: '🇬🇾',
  },
  {
    value: 'HK',
    label: 'Hong Kong',
    icon: '🇭🇰',
  },
  {
    value: 'HN',
    label: 'Honduras',
    icon: '🇭🇳',
  },
  {
    value: 'HR',
    label: 'Croatia',
    icon: '🇭🇷',
  },
  {
    value: 'HT',
    label: 'Haiti',
    icon: '🇭🇹',
  },
  {
    value: 'HU',
    label: 'Hungary',
    icon: '🇭🇺',
  },
  {
    value: 'ID',
    label: 'Indonesia',
    icon: '🇮🇩',
  },
  {
    value: 'IE',
    label: 'Ireland',
    icon: '🇮🇪',
  },
  {
    value: 'IL',
    label: 'Israel',
    icon: '🇮🇱',
  },
  {
    value: 'IM',
    label: 'Isle of Man',
    icon: '🇮🇲',
  },
  {
    value: 'IN',
    label: 'India',
    icon: '🇮🇳',
  },
  {
    value: 'IQ',
    label: 'Iraq',
    icon: '🇮🇶',
  },
  {
    value: 'IR',
    label: 'Iran, Islamic Republic of',
    icon: '🇮🇷',
  },
  {
    value: 'IS',
    label: 'Iceland',
    icon: '🇮🇸',
  },
  {
    value: 'IT',
    label: 'Italy',
    icon: '🇮🇹',
  },
  {
    value: 'JE',
    label: 'Jersey',
    icon: '🇯🇪',
  },
  {
    value: 'JM',
    label: 'Jamaica',
    icon: '🇯🇲',
  },
  {
    value: 'JO',
    label: 'Jordan',
    icon: '🇯🇴',
  },
  {
    value: 'JP',
    label: 'Japan',
    icon: '🇯🇵',
  },
  {
    value: 'KE',
    label: 'Kenya',
    icon: '🇰🇪',
  },
  {
    value: 'KG',
    label: 'Kyrgyzstan',
    icon: '🇰🇬',
  },
  {
    value: 'KH',
    label: 'Cambodia',
    icon: '🇰🇭',
  },
  {
    value: 'KI',
    label: 'Kiribati',
    icon: '🇰🇮',
  },
  {
    value: 'KM',
    label: 'Comoros',
    icon: '🇰🇲',
  },
  {
    value: 'KN',
    label: 'Saint Kitts and Nevis',
    icon: '🇰🇳',
  },
  {
    value: 'KP',
    label: "Korea, Democratic People's Republic of",
    icon: '🇰🇵',
  },
  {
    value: 'KR',
    label: 'Korea, Republic of',
    icon: '🇰🇷',
  },
  {
    value: 'KW',
    label: 'Kuwait',
    icon: '🇰🇼',
  },
  {
    value: 'KY',
    label: 'Cayman Islands',
    icon: '🇰🇾',
  },
  {
    value: 'KZ',
    label: 'Kazakhstan',
    icon: '🇰🇿',
  },
  {
    value: 'LA',
    label: "Lao People's Democratic Republic",
    icon: '🇱🇦',
  },
  {
    value: 'LB',
    label: 'Lebanon',
    icon: '🇱🇧',
  },
  {
    value: 'LC',
    label: 'Saint Lucia',
    icon: '🇱🇨',
  },
  {
    value: 'LI',
    label: 'Liechtenstein',
    icon: '🇱🇮',
  },
  {
    value: 'LK',
    label: 'Sri Lanka',
    icon: '🇱🇰',
  },
  {
    value: 'LR',
    label: 'Liberia',
    icon: '🇱🇷',
  },
  {
    value: 'LS',
    label: 'Lesotho',
    icon: '🇱🇸',
  },
  {
    value: 'LT',
    label: 'Lithuania',
    icon: '🇱🇹',
  },
  {
    value: 'LU',
    label: 'Luxembourg',
    icon: '🇱🇺',
  },
  {
    value: 'LV',
    label: 'Latvia',
    icon: '🇱🇻',
  },
  {
    value: 'LY',
    label: 'Libya',
    icon: '🇱🇾',
  },
  {
    value: 'MA',
    label: 'Morocco',
    icon: '🇲🇦',
  },
  {
    value: 'MC',
    label: 'Monaco',
    icon: '🇲🇨',
  },
  {
    value: 'MD',
    label: 'Moldova, Republic of',
    icon: '🇲🇩',
  },
  {
    value: 'ME',
    label: 'Montenegro',
    icon: '🇲🇪',
  },
  {
    value: 'MF',
    label: 'Saint Martin, (French part)',
    icon: '🇲🇫',
  },
  {
    value: 'MG',
    label: 'Madagascar',
    icon: '🇲🇬',
  },
  {
    value: 'MH',
    label: 'Marshall Islands',
    icon: '🇲🇭',
  },
  {
    value: 'MK',
    label: 'North Macedonia',
    icon: '🇲🇰',
  },
  {
    value: 'ML',
    label: 'Mali',
    icon: '🇲🇱',
  },
  {
    value: 'MM',
    label: 'Myanmar',
    icon: '🇲🇲',
  },
  {
    value: 'MN',
    label: 'Mongolia',
    icon: '🇲🇳',
  },
  {
    value: 'MO',
    label: 'Macao',
    icon: '🇲🇴',
  },
  {
    value: 'MP',
    label: 'Northern Mariana Islands',
    icon: '🇲🇵',
  },
  {
    value: 'MQ',
    label: 'Martinique',
    icon: '🇲🇶',
  },
  {
    value: 'MR',
    label: 'Mauritania',
    icon: '🇲🇷',
  },
  {
    value: 'MS',
    label: 'Montserrat',
    icon: '🇲🇸',
  },
  {
    value: 'MT',
    label: 'Malta',
    icon: '🇲🇹',
  },
  {
    value: 'MU',
    label: 'Mauritius',
    icon: '🇲🇺',
  },
  {
    value: 'MV',
    label: 'Maldives',
    icon: '🇲🇻',
  },
  {
    value: 'MW',
    label: 'Malawi',
    icon: '🇲🇼',
  },
  {
    value: 'MX',
    label: 'Mexico',
    icon: '🇲🇽',
  },
  {
    value: 'MY',
    label: 'Malaysia',
    icon: '🇲🇾',
  },
  {
    value: 'MZ',
    label: 'Mozambique',
    icon: '🇲🇿',
  },
  {
    value: 'NA',
    label: 'Namibia',
    icon: '🇳🇦',
  },
  {
    value: 'NC',
    label: 'New Caledonia',
    icon: '🇳🇨',
  },
  {
    value: 'NE',
    label: 'Niger',
    icon: '🇳🇪',
  },
  {
    value: 'NF',
    label: 'Norfolk Island',
    icon: '🇳🇫',
  },
  {
    value: 'NG',
    label: 'Nigeria',
    icon: '🇳🇬',
  },
  {
    value: 'NI',
    label: 'Nicaragua',
    icon: '🇳🇮',
  },
  {
    value: 'NL',
    label: 'Netherlands',
    icon: '🇳🇱',
  },
  {
    value: 'NO',
    label: 'Norway',
    icon: '🇳🇴',
  },
  {
    value: 'NP',
    label: 'Nepal',
    icon: '🇳🇵',
  },
  {
    value: 'NR',
    label: 'Nauru',
    icon: '🇳🇷',
  },
  {
    value: 'NU',
    label: 'Niue',
    icon: '🇳🇺',
  },
  {
    value: 'NZ',
    label: 'New Zealand',
    icon: '🇳🇿',
  },
  {
    value: 'OM',
    label: 'Oman',
    icon: '🇴🇲',
  },
  {
    value: 'PA',
    label: 'Panama',
    icon: '🇵🇦',
  },
  {
    value: 'PE',
    label: 'Peru',
    icon: '🇵🇪',
  },
  {
    value: 'PF',
    label: 'French Polynesia',
    icon: '🇵🇫',
  },
  {
    value: 'PG',
    label: 'Papua New Guinea',
    icon: '🇵🇬',
  },
  {
    value: 'PH',
    label: 'Philippines',
    icon: '🇵🇭',
  },
  {
    value: 'PK',
    label: 'Pakistan',
    icon: '🇵🇰',
  },
  {
    value: 'PL',
    label: 'Poland',
    icon: '🇵🇱',
  },
  {
    value: 'PM',
    label: 'Saint Pierre and Miquelon',
    icon: '🇵🇲',
  },
  {
    value: 'PN',
    label: 'Pitcairn',
    icon: '🇵🇳',
  },
  {
    value: 'PR',
    label: 'Puerto Rico',
    icon: '🇵🇷',
  },
  {
    value: 'PS',
    label: 'Palestine, State of',
    icon: '🇵🇸',
  },
  {
    value: 'PT',
    label: 'Portugal',
    icon: '🇵🇹',
  },
  {
    value: 'PW',
    label: 'Palau',
    icon: '🇵🇼',
  },
  {
    value: 'PY',
    label: 'Paraguay',
    icon: '🇵🇾',
  },
  {
    value: 'QA',
    label: 'Qatar',
    icon: '🇶🇦',
  },
  {
    value: 'RO',
    label: 'Romania',
    icon: '🇷🇴',
  },
  {
    value: 'RS',
    label: 'Serbia',
    icon: '🇷🇸',
  },
  {
    value: 'RU',
    label: 'Russian Federation',
    icon: '🇷🇺',
  },
  {
    value: 'RW',
    label: 'Rwanda',
    icon: '🇷🇼',
  },
  {
    value: 'SA',
    label: 'Saudi Arabia',
    icon: '🇸🇦',
  },
  {
    value: 'SB',
    label: 'Solomon Islands',
    icon: '🇸🇧',
  },
  {
    value: 'SC',
    label: 'Seychelles',
    icon: '🇸🇨',
  },
  {
    value: 'SD',
    label: 'Sudan',
    icon: '🇸🇩',
  },
  {
    value: 'SE',
    label: 'Sweden',
    icon: '🇸🇪',
  },
  {
    value: 'SG',
    label: 'Singapore',
    icon: '🇸🇬',
  },
  {
    value: 'SH',
    label: 'Saint Helena, Ascension and Tristan da Cunha',
    icon: '🇸🇭',
  },
  {
    value: 'SI',
    label: 'Slovenia',
    icon: '🇸🇮',
  },
  {
    value: 'SJ',
    label: 'Svalbard and Jan Mayen',
    icon: '🇸🇯',
  },
  {
    value: 'SK',
    label: 'Slovakia',
    icon: '🇸🇰',
  },
  {
    value: 'SL',
    label: 'Sierra Leone',
    icon: '🇸🇱',
  },
  {
    value: 'SM',
    label: 'San Marino',
    icon: '🇸🇲',
  },
  {
    value: 'SN',
    label: 'Senegal',
    icon: '🇸🇳',
  },
  {
    value: 'SO',
    label: 'Somalia',
    icon: '🇸🇴',
  },
  {
    value: 'SR',
    label: 'Suriname',
    icon: '🇸🇷',
  },
  {
    value: 'SS',
    label: 'South Sudan',
    icon: '🇸🇸',
  },
  {
    value: 'ST',
    label: 'Sao Tome and Príncipe',
    icon: '🇸🇹',
  },
  {
    value: 'SV',
    label: 'El Salvador',
    icon: '🇸🇻',
  },
  {
    value: 'SX',
    label: 'Sint Maarten, (Dutch part)',
    icon: '🇸🇽',
  },
  {
    value: 'SY',
    label: 'Syrian Arab Republic',
    icon: '🇸🇾',
  },
  {
    value: 'SZ',
    label: 'Eswatini',
    icon: '🇸🇿',
  },
  {
    value: 'TC',
    label: 'Turks and Caicos Islands',
    icon: '🇹🇨',
  },
  {
    value: 'TD',
    label: 'Chad',
    icon: '🇹🇩',
  },
  {
    value: 'TG',
    label: 'Togo',
    icon: '🇹🇬',
  },
  {
    value: 'TH',
    label: 'Thailand',
    icon: '🇹🇭',
  },
  {
    value: 'TJ',
    label: 'Tajikistan',
    icon: '🇹🇯',
  },
  {
    value: 'TK',
    label: 'Tokelau',
    icon: '🇹🇰',
  },
  {
    value: 'TL',
    label: 'Timor-Leste',
    icon: '🇹🇱',
  },
  {
    value: 'TM',
    label: 'Turkmenistan',
    icon: '🇹🇲',
  },
  {
    value: 'TN',
    label: 'Tunisia',
    icon: '🇹🇳',
  },
  {
    value: 'TO',
    label: 'Tonga',
    icon: '🇹🇴',
  },
  {
    value: 'TR',
    label: 'Türkiye',
    icon: '🇹🇷',
  },
  {
    value: 'TT',
    label: 'Trinidad and Tobago',
    icon: '🇹🇹',
  },
  {
    value: 'TV',
    label: 'Tuvalu',
    icon: '🇹🇻',
  },
  {
    value: 'TW',
    label: 'Taiwan, Province of China',
    icon: '🇹🇼',
  },
  {
    value: 'TZ',
    label: 'Tanzania, United Republic of',
    icon: '🇹🇿',
  },
  {
    value: 'UA',
    label: 'Ukraine',
    icon: '🇺🇦',
  },
  {
    value: 'UG',
    label: 'Uganda',
    icon: '🇺🇬',
  },
  {
    value: 'UM',
    label: 'United States Minor Outlying Islands',
    icon: '🇺🇲',
  },
  {
    value: 'US',
    label: 'United States of America',
    icon: '🇺🇸',
  },
  {
    value: 'UY',
    label: 'Uruguay',
    icon: '🇺🇾',
  },
  {
    value: 'UZ',
    label: 'Uzbekistan',
    icon: '🇺🇿',
  },
  {
    value: 'VA',
    label: 'Holy See',
    icon: '🇻🇦',
  },
  {
    value: 'VC',
    label: 'Saint Vincent and the Grenadines',
    icon: '🇻🇨',
  },
  {
    value: 'VE',
    label: 'Venezuela, Bolivarian Republic of',
    icon: '🇻🇪',
  },
  {
    value: 'VG',
    label: 'Virgin Islands, British',
    icon: '🇻🇬',
  },
  {
    value: 'VI',
    label: 'Virgin Islands, U.S.',
    icon: '🇻🇮',
  },
  {
    value: 'VN',
    label: 'Viet Nam',
    icon: '🇻🇳',
  },
  {
    value: 'VU',
    label: 'Vanuatu',
    icon: '🇻🇺',
  },
  {
    value: 'WF',
    label: 'Wallis and Futuna',
    icon: '🇼🇫',
  },
  {
    value: 'WS',
    label: 'Samoa',
    icon: '🇼🇸',
  },
  {
    value: 'XK',
    label: 'Kosovo',
    icon: '🇽🇰',
  },
  {
    value: 'YE',
    label: 'Yemen',
    icon: '🇾🇪',
  },
  {
    value: 'YT',
    label: 'Mayotte',
    icon: '🇾🇹',
  },
  {
    value: 'ZA',
    label: 'South Africa',
    icon: '🇿🇦',
  },
  {
    value: 'ZM',
    label: 'Zambia',
    icon: '🇿🇲',
  },
  {
    value: 'ZW',
    label: 'Zimbabwe',
    icon: '🇿🇼',
  },
]
